/*
 * @Date: 2023-11-28 18:30:45
 * @LastEditors: shizheng 64840669+code-cola-js@users.noreply.github.com
 * @LastEditTime: 2023-12-13 19:26:40
 * @FilePath: \hisea-ssr\src\components\FilterModal\filterFooter.js
 */
import { useStyle } from '@/classify';
import { useFilterFooter } from '@/hooks/FilterModal';
import cn from 'classnames';
import { useIntl } from 'react-intl';
import Button from '../Button';
import defaultClasses from './filterFooter.module.css';

const FilterFooter = props => {
  const { applyFilters, hasFilters, isOpen, clearAll, handleClose, handleReset, totalCount, loadingCount } = props;
  const { formatMessage } = useIntl();
  const { touched } = useFilterFooter({
    hasFilters,
    isOpen,
  });

  const classes = useStyle(defaultClasses, props.classes);
  const buttonLabel = formatMessage({
    id: 'filterFooter.results',
    defaultMessage: 'See Results',
  });

  return (
    <div className={classes.root}>
      {/* <Button
        className={classes.buttonConfirm}
        disabled={!touched}
        onClick={() => {
          applyFilters();
          handleClose();
        }}
        aria-label={buttonLabel}
        aria-disabled={!touched}
        priority='high'
      >
        {buttonLabel}
      </Button> */}
      <Button
        className='mb-[20px] flex h-[40px] w-full items-center justify-center rounded-[102px] bg-black font-roboto-medium text-[16px] font-medium leading-none text-white disabled_opacity-50 lg_hover_bg-4c4c4c'
        priority='high'
        disabled={!touched || totalCount === 0}
        onClick={() => {
          applyFilters();
          handleClose();
        }}
        aria-label={buttonLabel}
        aria-disabled={!touched || totalCount === 0}
        type='submit'
      >
        {buttonLabel} {!loadingCount && totalCount >= 0 && <span>({totalCount})</span>}
      </Button>
      <Button
        className={cn('mx-auto h-[30px]')}
        onClick={() => {
          handleReset();
          handleClose();
        }} // 确保作为函数调用
      >
        <span className=' font-roboto-regular text-[16px] font-normal leading-[24px] underline'>Clear All</span>
      </Button>
    </div>
  );
};

export default FilterFooter;
